import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import { CompanyInDto } from 'shared/dtos/in/company';
import { broadcastUploadedCompanyError } from 'serviceWorker/broadcasts/company/error';
import {
  broadcastCreatedCompany,
  broadcastDeletedCompany,
  broadcastUpdatedCompany,
  broadcastUploadedCompany,
} from 'serviceWorker/broadcasts/company/one';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';
import { projectIdOfRequest } from 'serviceWorker/helpers/dataScope';

export function broadcastCompanyResponse(
  request: HttpRequestEntity,
  response: CompanyInDto | any
): void {
  const { uniqueId } = request.data;
  if (response.error) {
    return broadcastUploadedCompanyError(response.error, chooseErrorMessage(response.error), uniqueId);
  }
  switch (request.method) {
    case 'POST':
      // Never rejects: a failure is broadcast as `failUploadedEntity` with the `uniqueId`.
      return void broadcastCreatedCompany(response, uniqueId, projectIdOfRequest(request));
    // A restore is queued as GET; its runner answers `true`.
    case 'GET':
      return broadcastUploadedCompany(response, uniqueId);
    case 'PUT':
      return broadcastUpdatedCompany(response, uniqueId);
    case 'DELETE':
      return broadcastDeletedCompany(response, uniqueId);
    default:
      neverReached(request.method);
  }
}

/** Carries the change's `uniqueId`, so the page's command rejects with this error. */
export function broadcastCompanyError(
  request: HttpRequestEntity,
  error: unknown,
  uniqueId?: string
): void {
  broadcastUploadedCompanyError(error, chooseErrorMessage(error), uniqueId ?? request.data?.uniqueId);
}
